module.exports = __webpack_public_path__ + "static/civic-logo-invert-a4b7b7b1d55c2efecfe7da81445394a9.svg";